import React, {useState} from 'react'
import {connect, useSelector} from "react-redux";

// components
import {ButtonCancel, ButtonSave} from "../buttons/buttonsActions";
import SelectScheduleType from "./SelectScheduleType";
import RecurringSchedule from "./RecurringSchedule";
import SelectWeekDay from "./SelectWeekDay";
import SelectSchedules from "./SelectSchedules";
import ViewSelectedHours from "./ViewSelectedHours";

// actions
import {save} from "../../redux/actions/hotel/afiPickupScheduleActions";

// utils
import {sortHours} from "../../util/DateTools";
import {Card, CardBody} from "reactstrap";
import {getStateByPath} from "../../redux/selectors";


const SelectSchedule = props => {
    const componentState = useSelector(state => getStateByPath(state, props?.path));
    const { domainObject:afi, app, udn } = componentState?.data;
    const fbDataBaseId = app?.fbDataBase?.id
    const { onClose } = props

    const [recurrentHours, setRecurrentHours] = useState() // para determinar si tiene o no tiene horario recurrente
    const [allDays, setAllDays] = useState(false) // para determinar si el horario aplica para todos los días
    const [viewMode, setViewMode] = useState('SELECT_DAY') // determinar si se mostrará la vista de selección del día o de las horas
    const [selectedDays, setSelectedDays] = useState([]) // dia seleccionado para asignar horarios
    const [selectedHours, setSelectedHours] = useState([]) // horarios seleccionados
    const [loading, setLoading] = useState(false)
    const disabledSave = selectedHours.length == 0 //para deshabilitar el guardado de la información si no se ha seleccionado ningun horario


    /**
     * función a ejecutar cuando se seleccione un día
     * @param days
     */
    const onDayChange = (days, isForAllDays = false) => {
        if(isForAllDays)
            setAllDays(true)

        setSelectedDays(days)
        setViewMode('SELECT_HOUR')
    }


    /**
     * Función a ejecutar cuando se seleccione un horario
     * @param hour
     */
    const onAddHour = (hour) => {
        if(!hour || hour === '')
            return

        if(selectedHours.includes(hour))
            return

        setSelectedHours( hours => sortHours([...hours, hour]) )
    }


    /**
     * Función a ejecutar cuando se quite un horario de la lista
     * @param i
     */
    const onRemoveHour = i => {
        const newHours = selectedHours.filter( (value, index) => index !== i)
        setSelectedHours( newHours )
    }


    /**
     * Función a ejecutar al guardar los horarios
     */
    const onConfirmSelectedHours = () => {
        const request = {
            fbDataBase: {id: fbDataBaseId},
            item: {
                udnFrom: {id: udn?.id},
                afi: {id: afi?.id},
                allDays,
                days: selectedDays,
                hours:selectedHours
            }
        }

        setLoading(true)

        props.save(request, changeLoading)
    }

    const changeLoading = (value) => {
        setLoading(!loading)
        onClose()
    }

    return <center>

        {
            // muestra para determinar si tendrá horario recurrente
            recurrentHours == null && <SelectScheduleType setRecurrentHours={setRecurrentHours} />
        }

        {
            // muestra para capturar el horario recurrente
            recurrentHours == true && <RecurringSchedule {...props} />
        }


        {
            // muestra para capturar el día de la semana
            (recurrentHours == false && viewMode === 'SELECT_DAY') && <SelectWeekDay
                    defaultDay={selectedDays}
                    onClose={ onClose }
                    setExternalValue={onDayChange}
                />
        }
        {
            // mostrar para seleccionar y visualizar los horarios
            (recurrentHours == false && viewMode !== 'SELECT_DAY') &&<>
                <SelectSchedules setExternalValue={onAddHour} />
                <ViewSelectedHours selectedHours={selectedHours} onRemoveHour={onRemoveHour} />
                <br/>
                <ButtonSave onClick={ onConfirmSelectedHours } disabled={ disabledSave || loading } loading={loading}/>
            </>
        }
    </center>
}

const mapStateToProps = state => ({});
const mapActionsToProps = ({ save })

export default connect(mapStateToProps, mapActionsToProps)(SelectSchedule)